import { ChangeDetectionStrategy, Component } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  year = new Date().getFullYear();

  private buildNumber = environment.appBuildNumber ? ` (Build: ${environment.appBuildNumber})` : '';
  version = `${environment.appVersion}${this.buildNumber}`;
}
